import _defineProperty from "@babel/runtime/helpers/defineProperty";
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled
import { css } from '@emotion/react';
import { blanketSelectionStyles, borderSelectionStyles, hideNativeBrowserTextSelectionStyles } from './selectionStyles';
var gridMediumMaxWidth = 1024;
var akEditorSelectedNodeClassName = 'ak-editor-selected-node';
var selectorForNotResizedLayoutInFulllWidthEditor = '.fabric-editor--full-width-mode .ProseMirror > .layoutSectionView-content-wrap';
var selectorForNotResizedLayoutInFixedWidthEditor = '.ak-editor-content-area:not(.fabric-editor--full-width-mode) .ProseMirror > .layoutSectionView-content-wrap';
var selectorForResizedLayoutInFullOrFixedWidthEditor = '.ProseMirror .fabric-editor-breakout-mark .layoutSectionView-content-wrap';
var layoutResponsiveSelectedSelector = "&.selected, &:hover, &.selected.danger, &.".concat(akEditorSelectedNodeClassName, ":not(.danger)");
var layoutSelectedSelector = "&.selected, [data-empty-layout='true'], &:hover, &.selected.danger [data-layout-section], &.".concat(akEditorSelectedNodeClassName, ":not(.danger) [data-layout-section]");

/**
 * Layout columns styles when advanced layouts experiment is on
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles
export var layoutColumnStylesAdvanced = css({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.ProseMirror [data-layout-section]': _defineProperty(_defineProperty({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '> [data-layout-column]': {
      margin: '0 4px'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-selectors
    '> [data-layout-column]:first-of-type': {
      marginLeft: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-selectors
    '> [data-layout-column]:last-of-type': {
      marginRight: 0
    }
  }, "@media screen and (max-width: ".concat(gridMediumMaxWidth, "px)"), {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-layout-column] + [data-layout-column]': {
      margin: 0
    }
  }), "> [data-layout-column].".concat(akEditorSelectedNodeClassName, ":not(.danger)"), [
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
  blanketSelectionStyles,
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
  hideNativeBrowserTextSelectionStyles, {
    // layout column selection shorter after layout border has been removed
    '::before': {
      width: 'calc(100% - 8px)',
      left: 4,
      borderRadius: "var(--ds-radius-small, 3px)"
    }
  }])
});

/**
 * Layout columns styles when advanced layouts experiment is off
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles
export var layoutColumnStylesNotAdvanced = css({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.ProseMirror [data-layout-section]': _defineProperty({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-layout-column] + [data-layout-column]': {
      // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
      marginLeft: 8
    }
  }, "@media screen and (max-width: ".concat(gridMediumMaxWidth, "px)"), {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-layout-column] + [data-layout-column]': {
      marginLeft: 0
    }
  })
});

/**
 * Responsive styles for layout columns when advanced layouts experiment is on
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles
export var layoutColumnResponsiveStyles = css({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.ProseMirror [data-layout-section]': {
    display: 'flex',
    flexDirection: 'row',
    gap: "var(--ds-space-100, 8px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '& > *': {
      flex: 1,
      minWidth: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '& > .unsupportedBlockView-content-wrap': {
      minWidth: 'initial'
    }
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  '.layout-section-container': {
    containerType: 'inline-size',
    containerName: 'layout-area'
  }
});

/**
 * Layout section styles when advanced layouts experiment is on
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-exported-styles
export var layoutSectionStylesAdvanced = css({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.ProseMirror .layout-section-container [data-layout-section]': {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '> .ProseMirror-widget': {
      flex: 'none',
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
      display: 'contents !important',
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
      '&[data-blocks-drag-handle-container] div': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
        display: 'contents !important'
      },
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
      '&[data-blocks-drop-target-container]': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
        display: 'block !important',
        margin: "var(--ds-space-negative-050, -4px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-drop-target-for-element]': {
          position: 'absolute'
        }
      },
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
      '& + [data-layout-column]': {
        margin: 0
      }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '> [data-layout-column]': {
      margin: 0
    }
  }
});

/**
 * Layout section styles when advanced layouts experiment is off
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles
export var layoutSectionStylesNotAdvanced = css({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  '.ProseMirror [data-layout-section]': _defineProperty({
    position: 'relative',
    display: 'flex',
    flexDirection: 'row',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > *': {
      flex: 1,
      minWidth: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > .unsupportedBlockView-content-wrap': {
      minWidth: 'initial'
    }
  }, "@media screen and (max-width: ".concat(gridMediumMaxWidth, "px)"), {
    flexDirection: 'column'
  })
});

/**
 * Selected styles for layout when advanced layouts experiment is off
 */
// TODO: DSP-4441 - Remove the border styles below once design tokens have been enabled and fallbacks are no longer triggered.
//       This is because the default state already uses the same token and, as such, the hover style won't change anything.
//       https://product-fabric.atlassian.net/browse/DSP-4441
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles
export var layoutSelectedStylesNotAdvanced = css({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.ProseMirror': {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-layout-section], .layoutSectionView-content-wrap': _defineProperty({
      // Shows the border when cursor is inside a layout
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
      '&.selected [data-layout-column], &:hover [data-layout-column]': {
        border: "1px solid ".concat("var(--ds-border, #091E4224)")
      },
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
      '&.selected.danger [data-layout-column]': {
        backgroundColor: "var(--ds-background-danger, #FFECEB)",
        borderColor: "var(--ds-border-danger, #E2483D)"
      }
    }, "&.".concat(akEditorSelectedNodeClassName, ":not(.danger)"), {
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
      '[data-layout-column]': [
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
      borderSelectionStyles,
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
      blanketSelectionStyles,
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
      hideNativeBrowserTextSelectionStyles, {
        '::after': {
          backgroundColor: 'transparent'
        }
      }]
    })
  }
});

// TODO: ED-28075 - inline rowSeparatorBaseStyles to unblock Compiled CSS migration
var rowSeparatorBaseStyles = css({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-layout-content]::before': {
    content: "''",
    borderTop: "1px solid ".concat("var(--ds-border, #091E4224)"),
    position: 'absolute',
    width: 'calc(100% - 32px)',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
    marginTop: -13,
    // clear styles for column separator
    borderLeft: 'unset',
    marginLeft: 'unset',
    height: 'unset'
  }
});

/**
 * Selected styles for layout when advanced layouts experiment is on
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles
export var layoutSelectedStylesAdvanced = css({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.ProseMirror': {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-layout-section], .layoutSectionView-content-wrap': _defineProperty(_defineProperty(_defineProperty({}, layoutSelectedSelector, {
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
      '[data-layout-column]:not(:first-of-type) [data-layout-content]::before': {
        content: "''",
        borderLeft: "1px solid ".concat("var(--ds-border, #091E4224)"),
        position: 'absolute',
        height: 'calc(100% - 24px)',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginLeft: -25
      }
    }), '&.selected.danger [data-layout-section]', {
      backgroundColor: "var(--ds-background-danger, #FFECEB)",
      boxShadow: "0 0 0 1px ".concat("var(--ds-border-danger, #E2483D)"),
      borderRadius: "var(--ds-radius-small, 4px)"
    }), "&.".concat(akEditorSelectedNodeClassName, ":not(.danger) [data-layout-section]"), {
      boxShadow: "0 0 0 1px ".concat("var(--ds-border-selected, #0C66E4)"),
      borderRadius: "var(--ds-radius-small, 4px)",
      backgroundColor: "var(--ds-background-selected, #E9F2FF)",
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
      '[data-layout-column]': [
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
      blanketSelectionStyles,
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
      hideNativeBrowserTextSelectionStyles, {
        border: 0,
        '::before': {
          backgroundColor: 'transparent'
        }
      }]
    })
  }
});

/**
 * Base responsive styles for layout
 */
// jest warning: JSDOM version (22) doesn't support the new @container CSS rule
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles
export var layoutResponsiveBaseStyles = css(_defineProperty(_defineProperty(_defineProperty({}, selectorForNotResizedLayoutInFulllWidthEditor, _defineProperty({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-layout-section]': {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries
    '@container editor-area (max-width:724px)': {
      flexDirection: 'column'
    }
  }
}, layoutResponsiveSelectedSelector, {
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-selectors
  '[data-layout-column]:not(:first-of-type)': _defineProperty({}, "@container editor-area (max-width:724px)", rowSeparatorBaseStyles)
})), selectorForNotResizedLayoutInFixedWidthEditor, _defineProperty({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-layout-section]': {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries
    '@container editor-area (max-width:788px)': {
      flexDirection: 'column'
    }
  }
}, layoutResponsiveSelectedSelector, {
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-selectors
  '[data-layout-column]:not(:first-of-type)': _defineProperty({}, "@container editor-area (max-width:788px)", rowSeparatorBaseStyles)
})), selectorForResizedLayoutInFullOrFixedWidthEditor, _defineProperty({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-layout-section]': {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries
    '@container editor-area (max-width:820px)': {
      flexDirection: 'column'
    }
  }
}, layoutResponsiveSelectedSelector, {
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-selectors
  '[data-layout-column]:not(:first-of-type)': _defineProperty({}, "@container editor-area (max-width:820px)", rowSeparatorBaseStyles)
})));

/**
 * Responsive styles for layout in view mode
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles
export var layoutResponsiveStylesForView = css(_defineProperty(_defineProperty(_defineProperty({}, selectorForNotResizedLayoutInFulllWidthEditor, _defineProperty({}, layoutResponsiveSelectedSelector, {
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-selectors
  '[data-layout-column]:not(:first-of-type)': _defineProperty({}, "@container editor-area (max-width:724px)", {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-layout-content]::before': {
      borderTop: 0
    }
  })
})), selectorForNotResizedLayoutInFixedWidthEditor, _defineProperty({}, layoutResponsiveSelectedSelector, {
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-selectors
  '[data-layout-column]:not(:first-of-type)': _defineProperty({}, "@container editor-area (max-width:788px)", {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-layout-content]::before': {
      borderTop: 0
    }
  })
})), selectorForResizedLayoutInFullOrFixedWidthEditor, _defineProperty({}, layoutResponsiveSelectedSelector, {
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-selectors
  '[data-layout-column]:not(:first-of-type)': _defineProperty({}, "@container editor-area (max-width:820px)", {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-layout-content]::before': {
      borderTop: 0
    }
  })
})));

/**
 * Base styles for layout
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Needs manual remediation
export var layoutBaseStyles = css({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-nested-selectors
  '.ProseMirror': {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-layout-section]': {
      margin: "var(--ds-space-100, 8px)".concat(" -12px 0"),
      transition: 'border-color 0.3s cubic-bezier(0.15, 1, 0.3, 1)',
      cursor: 'pointer',
      // Inner cursor located 26px from left
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
      '[data-layout-column]': {
        flex: 1,
        position: 'relative',
        minWidth: 0,
        /* disable 4 borders when in view mode and advanced layouts is on */
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
        border: "var(--ds-border-width, 1px)".concat(" solid ", "var(--ds-border, #091E4224)"),
        borderRadius: "var(--ds-radius-small, 4px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
        padding: "var(--ds-space-150, 12px)",
        boxSizing: 'border-box',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '> div': {
          // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
          '> .embedCardView-content-wrap:first-of-type .rich-media-item': {
            marginTop: 0
          },
          // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
          '> .mediaSingleView-content-wrap:first-of-type .rich-media-item': {
            marginTop: 0
          },
          // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
          '> .ProseMirror-gapcursor.-right:first-child + .mediaSingleView-content-wrap .rich-media-item, > style:first-child + .ProseMirror-gapcursor.-right + .mediaSingleView-content-wrap .rich-media-item, > .ProseMirror-gapcursor.-right:first-of-type + .embedCardView-content-wrap .rich-media-item': {
            marginTop: 0
          },
          // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
          '> .ProseMirror-gapcursor:first-child + span + .mediaSingleView-content-wrap .rich-media-item, > style:first-child + .ProseMirror-gapcursor + span + .mediaSingleView-content-wrap .rich-media-item': {
            marginTop: 0
          },
          // Prevent first DecisionWrapper's margin-top: 8px from shifting decisions down and shrinking layout's node selectable area (leniency margin)
          // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
          "> [data-node-type='decisionList']": {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            'li:first-of-type [data-decision-wrapper]': {
              marginTop: 0
            }
          }
        },
        // Make the 'content' fill the entire height of the layout column to allow click handler of layout section nodeview to target only data-layout-column
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-layout-content]': {
          height: '100%',
          cursor: 'text',
          // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
          '.mediaGroupView-content-wrap': {
            clear: 'both'
          }
        }
      }
    }
  },
  // hide separator when element is dragging on top of a layout column
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-blocks-drop-target-container] ~ [data-layout-column] > [data-layout-content]::before': {
    display: 'none'
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.fabric-editor--full-width-mode .ProseMirror': {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-layout-section]': {
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
      '.pm-table-container': {
        margin: '0 2px'
      }
    }
  }
});

/**
 * Base styles overrides for layout columns when advanced layouts experiment is on
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles
export var layoutBaseStylesAdvanced = css({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.ProseMirror [data-layout-section] [data-layout-column]': {
    border: 0
  }
});

/**
 * Spacing overrides when platform_editor_nested_dnd_styles_changes is on
 */
// TODO: EDF-123 - Migrate away from gridSize
// Recommendation: Replace directly with 7px
// Ignored via go/ees007
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles
export var layoutBaseStylesFixesUnderNestedDnDFG = css({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.ProseMirror [data-layout-section]': {
    margin: "var(--ds-space-100, 8px)".concat(" -20px 0")
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.ProseMirror [data-layout-section] [data-layout-column]': {
    padding: '12px 20px'
  }
});

/**
 * Layout in view mode styles for selected state when advanced layouts experiment is on.
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Needs manual remediation
export var layoutSelectedStylesForViewAdvanced = css({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.ProseMirror': {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-layout-section], .layoutSectionView-content-wrap': _defineProperty(_defineProperty(_defineProperty({}, layoutSelectedSelector, {
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
      '[data-layout-column]:not(:first-of-type) [data-layout-content]::before': {
        borderLeft: 0
      }
    }), '&.selected.danger [data-layout-section]', {
      boxShadow: "0 0 0 0 ".concat("var(--ds-border-danger, #E2483D)")
    }), "&.".concat(akEditorSelectedNodeClassName, ":not(.danger) [data-layout-section]"), {
      boxShadow: "0 0 0 0 ".concat("var(--ds-border-selected, #0C66E4)")
    })
  }
});

/**
 * Layout in view mode styles for selected state when advanced layouts experiment is off.
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles
export var layoutSelectedStylesForViewNotAdvanced = css({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.ProseMirror': {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-layout-section], .layoutSectionView-content-wrap': {
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
      '&.selected [data-layout-column], &:hover [data-layout-column]': {
        border: 0
      }
    }
  }
});

/*
 * Layout in view mode styles, overrides over layout base styles
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Needs manual remediation
export var layoutStylesForView = css({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.ProseMirror': {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-layout-section]': {
      cursor: 'default',
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
      '[data-layout-column]': {
        border: 0
      }
    }
  }
});

/*
 * marginTop fixes when platform_editor_nested_dnd_styles_changes is on
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles
export var layoutColumnMartinTopFixesNew = css({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.ProseMirror [data-layout-section] [data-layout-column] > div': {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '> :nth-child(1 of :not(style, .ProseMirror-gapcursor, .ProseMirror-widget, span))': {
      marginTop: 0
    }
  }
});

/*
 * marginTop fixes when platform_editor_nested_dnd_styles_changes is off
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles
export var layoutColumnMartinTopFixesOld = css({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.ProseMirror [data-layout-section] [data-layout-column] > div': {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-selectors
    '> :not(style):first-child, > style:first-child + *': {
      marginTop: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-selectors
    '> .ProseMirror-gapcursor:first-child + *, > style:first-child + .ProseMirror-gapcursor + *': {
      marginTop: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-selectors
    '> .ProseMirror-gapcursor:first-child + span + *': {
      marginTop: 0
    }
  }
});